/**
 * Relay connection helpers for commission catalog mocks.
 * Shape matches BackofficeCommission*Connection in pga-backend graphql-schemas/backoffice.graphql.
 */
export const emptyPageInfo = {
  __typename: "PageInfo" as const,
  hasNextPage: false,
  hasPreviousPage: false,
  startCursor: null as string | null,
  endCursor: null as string | null
};

export function buildConnection<TNode extends { __typename: string }>(
  typename: string,
  nodes: TNode[],
  pageInfo = emptyPageInfo
) {
  return {
    __typename: typename,
    nodes,
    totalCount: nodes.length,
    pageInfo
  };
}
